<template>
  <li class="cascader-item">
    <p class="cascader-item-p" @click="router(data)">{{ data.label }}</p>
  </li>
</template>

<script>
export default {
  name: "CascaderItem",
  props: {
    data: Object
  },
  methods: {
    router(data) {
      if (data.path != undefined) {
        // console.log("path11111111", path);
        this.$router.push(data.path);
        this.$emit('getAcived',data);
      }
    }
  }
};
</script>

<style scoped lang="less">
.cascader-item {
  width: 12rem;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;
  .cascader-item-p {
    padding: 0.8rem 1rem;
    margin: 0;
    &:hover {
      background-color: #409eff;
      color: #fff;
      border-radius: 0.5rem;
      transition: background-color 0.3s;
    }
  }
}
</style>
